/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILobasDigitalAssetDownloadViewProps } from './lobas-digital-asset-download';

export default (props: ILobasDigitalAssetDownloadViewProps) => {
    return (
        <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
            {props.lobasDigitalAssetDownloadContainer}
        </div>
    );
};
